import { SignUp } from '@clerk/react'

export default function Register() {
  return (
    <div
      className="min-vh-100 d-flex flex-column align-items-center justify-content-center gap-4"
      style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #6610f2 100%)' }}
    >
      {/* Branding above the Clerk widget */}
      <div className="text-center text-white">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
          style={{ width: 72, height: 72, background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(8px)' }}
        >
          <i className="bi bi-heart-pulse-fill fs-2"></i>
        </div>
        <h3 className="fw-bold mb-1">ConsultAiDoc</h3>
        <p className="opacity-75 small mb-0">Create your account to get started</p>
      </div>

      {/* Clerk SignUp widget */}
      <SignUp
        routing="path"
        path="/register"
        signInUrl="/login"
        fallbackRedirectUrl="/dashboard"
        appearance={{
          elements: {
            rootBox: { width: '100%', maxWidth: 420 },
            card: {
              borderRadius: '1rem',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              border: 'none',
            },
            headerTitle: { display: 'none' },
            headerSubtitle: { display: 'none' },
            socialButtonsBlockButton: {
              borderRadius: '0.5rem',
              fontWeight: 600,
            },
            formButtonPrimary: {
              background: 'linear-gradient(135deg, #0d6efd, #6610f2)',
              borderRadius: '0.5rem',
              fontWeight: 600,
            },
            footerActionLink: { color: '#0d6efd', fontWeight: 600 },
          },
        }}
      />
    </div>
  )
}
